export default {
  // Avue 内置文案会通过 main.js 的 i18n 钩子取 tip.* 子键（如输入框/下拉框占位符），
  // 因此 tip 必须是对象；$t("tip") 的调用点统一改用 $t("tip.title")
  tip: {
    title: "提示",
    input: "请输入",
    select: "请选择",
  },
  title: "掌终宝销售自动化管理平台",
  logoutTip: "退出系统, 是否继续?",
  submitText: "确定",
  cancelText: "取消",
  search: "请输入搜索内容",
  menuTip: "没有发现菜单",
  wel: {
    info: "早安，Smallwei，Avuex一款超乎你想象的框架！",
    dept: "我是avue团队下的一个部门-哈皮部门-哈皮职位",
    team: "团队内排名",
    project: "项目访问",
    count: "项目数",
    data: {
      subtitle: "实时",
      column1: "分类统计",
      column2: "附件统计",
      column3: "文章统计",
      key1: "分",
      key2: "附",
      key3: "评",
      text1: "当前分类总记录数",
      text2: "当前上传的附件数",
      text3: "评论次数",
    },
    data2: {
      column1: "今日注册",
      column2: "今日登录",
      column3: "今日订阅",
      column4: "今日评论",
    },
    data3: {
      column1: "转化率（日同比 28%）",
      column2: "签到率（日同比 11%）",
      column3: "签到率（日同比 11%）",
    },
    data4: {
      column1: "错误日志",
      column2: "数据展示",
      column3: "权限管理",
      column4: "用户管理",
    },
    table: {
      rw: "工作任务",
      nr: "工作内容",
      sj: "工作时间",
    },
  },
  route: {
    info: "个人信息",
    website: "官网",
    dashboard: "首页",
    tags: "标签",
    store: "本地存储",
    api: "全局函数",
    logs: "日志监控",
    table: "表格",
    form: "表单",
    data: "数据展示",
    permission: "权限",
    error: "异常页面",
    test: "测试页面",
  },
  login: {
    title: "登录",
    info: "SFA 销售自动化管理平台",
    tenantId: "请输入租户ID",
    username: "请输入账号",
    password: "请输入密码",
    wechat: "微信",
    qq: "QQ",
    github: "github",
    gitee: "码云",
    phone: "请输入手机号",
    code: "请输入验证码",
    submit: "登录",
    userLogin: "账号密码",
    phoneLogin: "手机号登录",
    thirdLogin: "第三方登录",
    msgText: "发送验证码",
    msgSuccess: "秒后重发",
  },
  navbar: {
    logOut: "退出登录",
    userinfo: "个人信息",
    dashboard: "首页",
    lock: "锁屏",
    bug: "没有错误日志",
    bugs: "条错误日志",
    screenfullF: "退出全屏",
    screenfull: "全屏",
    language: "中英文",
    theme: "主题",
    color: "换色",
  },
  tagsView: {
    menu: "更多",
    closeOthers: "关闭其它",
    closeAll: "关闭所有",
  },
  // avue 表单（搜索区）按钮使用 form.{emptyBtn|mockBtn|printBtn|submitBtn}
  form: {
    emptyBtn: "清 空",
    mockBtn: "模 拟",
    printBtn: "打 印",
    submitBtn: "提 交",
  },
  crud: {
    // avue 弹窗标题使用 crud.{add|edit|view|copy}Title
    addTitle: "新增",
    editTitle: "编辑",
    viewTitle: "查看",
    copyTitle: "复制",
    filter: "过滤",
    menu: "操 作",
    addBtn: "新 增",
    editBtn: "编 辑",
    delBtn: "删 除",
    viewBtn: "查 看",
    searchBtn: "查 询",
    emptyBtn: "重 置",
    selectBtn: "选 择",
    cancelBtn: "取 消",
    updateBtn: "修 改",
    saveBtn: "保 存",
    printBtn: "打 印",
    excelBtn: "导 出",
    submitBtn: "提 交",
    goTabBtn: "去处理",
    title: "常规表格",
    menuTitle: "菜单",
    name: "名称",
    date: "日期",
    user: "用户",
    address: "地址",
    province: "省份",
    city: "城市",
    module: "模块",
    moduleName: "模块名称",
    parentId: "父节点",
    icon: "图标",
    sort: "排序",
    url: "地址",
    params: "参数",
    menuType: "类型",
    explain: "说明",
    status: "状态",
    enable: "启用",
    disable: "禁用",
    clicknum: "点击量",
    show: "显示",
    hide: "隐藏",
  },
};
